// extracted by mini-css-extract-plugin
export default {"boton":"styles_boton__xUcGi","menuItem":"styles_menuItem__QPJrT","headerInternoRoute":"styles_headerInternoRoute__yofjo"};